// CSS Modules - component class name prefix: ShopCartLink__

<template>
  <span>
    <Button
      colour="orange"
      :text="waitingForResponse ? addButtonLoadingText : item.text"
      @onSimpleClick="addItem"
      :isDisabled="waitingForResponse"
    />
    <p
      v-if="addItemFailed"
      :class="[$style.errorText, { [$style.darkBackground]: isDarkBackground }]"
    >
      {{ addItemFailedMsg }}
    </p>
    <p
      v-if="addItemAmountMessage"
      :class="[
        $style.warningText,
        { [$style.darkBackground]: isDarkBackground }
      ]"
    >
      {{ addItemAmountMsgTxt }}
    </p>
  </span>
</template>

<script>
import getQuoteIdFromUrl from "../../xhr/shopCart/getQuoteIdFromUrl";
import addItemToUrl from "../../xhr/shopCart/addItemToUrl";
import CustomEvents from "../../globals/constants/customEvents";
import Button from "../Button/Button";

export default {
  name: "ShopCartLink",
  components: { Button },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    addButtonLoadingText: {
      type: String,
      default: ""
    },
    addItemFailedMsg: {
      type: String,
      default: ""
    },
    addItemAmountMsgTxt: {
      type: String,
      default: ""
    },
    addItemHighestAmountMsg: {
      type: String,
      default: ""
    },
    addItemLowestAmountMsg: {
      type: String,
      default: ""
    },
    addItemMultipleAmountMsg: {
      type: String,
      default: ""
    },
    isDarkBackground: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addItemFailed: false,
      addItemAmountMessage: false,
      waitingForResponse: false
    };
  },
  methods: {
    addItem() {
      this.addItemFailed = false;
      this.addItemAmountMessage = false;
      var addItemAmountMsgTxt = this.addItemAmountMsgTxt;
      var addItemHighestAmountMsg = this.addItemHighestAmountMsg;
      var addItemLowestAmountMsg = this.addItemLowestAmountMsg;
      var addItemMultipleAmountMsg = this.addItemMultipleAmountMsg;
      this.waitingForResponse = true;

      getQuoteIdFromUrl(window.getQuoteIdUrl)
        .then(quoteId => {
          addItemToUrl(window.addItemUrl, {
            itemid: this.item.id,
            quantity: this.item.quantity,
            country: window.currentCountry,
            language: window.currentLanguage,
            quoteid: quoteId,
            headline: this.item.headline,
            subheadline: this.item.subheadline,
            pictureurl: this.item.pictureurl,
            thumbnailurl: this.item.thumbnailurl,
            producturl: this.item.producturl
          })
            .then(response => {
              this.waitingForResponse = false;
              //We will add amountMessage handling
              if (
                typeof response.data.amountMessage !== "undefined" &&
                response.data.amountMessage != null &&
                response.data.amountMessage != ""
              ) {
                //Try to get message and value which is seperated by semicolon in json response
                var strAmountMessage = "";
                var partsOfAmountMessage = response.data.amountMessage.split(
                  ";"
                );
                if (partsOfAmountMessage[0].includes("highestAmount")) {
                  strAmountMessage = addItemHighestAmountMsg.replace(
                    "###amountValue###",
                    partsOfAmountMessage[1]
                  );
                }
                if (partsOfAmountMessage[0].includes("lowestAmount")) {
                  strAmountMessage = addItemLowestAmountMsg.replace(
                    "###amountValue###",
                    partsOfAmountMessage[1]
                  );
                }
                if (partsOfAmountMessage[0].includes("multipleAmount")) {
                  strAmountMessage = addItemMultipleAmountMsg.replace(
                    "###amountValue###",
                    partsOfAmountMessage[1]
                  );
                }
                addItemAmountMsgTxt = strAmountMessage;
                this.addItemAmountMessage = true;
              }
              const event = new CustomEvent(CustomEvents.ADD_TO_CART, {
                detail: response.data
              });
              window.dispatchEvent(event);
              this.$emit("closed");
            })
            .catch(error => {
              this.addItemFailed = true;
              this.waitingForResponse = false;
              console.error(error);

              if (error.data) {
                this.$emit("error", error.data);
              }
            });
        })
        .catch(error => {
          this.addItemFailed = true;
          this.waitingForResponse = false;
          console.error(error);
        });
    }
  }
};
</script>

<style module lang="scss">
@import "./ShopCartLink.scss";
</style>
